export const updateUser = /* GraphQL */ `
  mutation updateUser(
    $input: UpdateUserInput,!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      nome
      photo_url
    }
  }
`;